import { LatLng } from 'leaflet';
import qs from 'qs';

export default class NavitationService {
  /**
   * url to the google maps service
   */
  static googleMapsUrl = 'https://www.google.com/maps/dir/';
  static wazeMapsUrl = 'https://www.waze.com/pl/live-map/directions';

  /**
   * Generates a ling to google maps navigation service from two {LatLng} objects
   * @param from {LatLng} starting position
   * @param to {LatLng} destination position
   */
  static generateNavigationLink(from: LatLng, to: LatLng) {
    const params: any = {
      api: 1,
      origin: `${from.lat},${from.lng}`,
      destination: `${to.lat},${to.lng}`,
    };

    return `${this.googleMapsUrl}?${qs.stringify(params)}`;
  }

  static generateWazeNavigationLink(from: LatLng, to: LatLng) {
    return `${this.wazeMapsUrl}?to=ll.${to.lat},${to.lng}&from=ll.${from.lat},${from.lng}`;
  }
}
